import 'vue-multiselect/dist/vue-multiselect.min.css';

import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import ICampaignTds from "@/interfaces/ICampaignTds";
import ISlug from "@/interfaces/ISlug";
import ISelectItemDefault from "@/interfaces/selects/ISelectItemDefault";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import isEmpty from "@/libs/isEmpty";
import {transformMultiSelect} from "@/libs/transformData/transformMultiSelect";
import valueFromStrToObject from "@/libs/valueFromStrToObject";
import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import Loader from '@/components/Includes/Loader/Loader.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import {Switch as cSwitch} from '@coreui/vue';

@Component({
    name: 'CampaignTdsForm',
    components: {
        Loader,
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class CampaignTdsForm extends Vue {
    @Prop(Object) private itemCampaignTds!: ICampaignTds;

    @Prop(Array) private landings!: ISelectItemDefault[];
    @Prop(Array) private countries!: IMultiSelectItem[];
    @Prop(Array) private osForTds!: IMultiSelectItem[];

    // Begin Vuex Logic for Campaign TDS
    @Action private subscriptionsCampaignTdsList!: (query: IPayloadQuery) => number;
    @Getter private subscriptionsGetCampaignTdsList!: () => ICampaignTds[];
    // End Vuex Logic for Campaign TDS

    // Begin Vuex Logic for Apple Models
    @Action private subscriptionsAppleModelsList!: () => Promise<void>;
    @Getter private subscriptionsGetAppleModels!: () => ISlug[];
    // End Vuex Logic for Apple Models

    private modelsForTds: IMultiSelectItem[] = [];

    private transformValue(value: any): string {
        return value ? String(value) : '–';
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        return field === 'campaign' || field === 'id';
    }

    private changedCountries(countriesData: any) {
        this.itemCampaignTds.countrySet = countriesData.map((country: IMultiSelectItem) => country.value);
        valueFromStrToObject('countrySet', this.itemCampaignTds, this.countries);
    }

    private changedOS(osData: any) {
        this.itemCampaignTds.osSet = osData.map((os: IMultiSelectItem) => os.value);
        valueFromStrToObject('osSet', this.itemCampaignTds, this.osForTds);
    }

    private changedModels(appleModels: any) {
        this.itemCampaignTds.modelSet = appleModels.map((os: IMultiSelectItem) => os.value);
        valueFromStrToObject('modelSet', this.itemCampaignTds, this.modelsForTds);
    }

    private async mounted() {
        try {
            this.modelsForTds = transformMultiSelect(this.subscriptionsGetAppleModels(), 'title', 'slug');
            if (isEmpty(this.modelsForTds)) {
                await this.subscriptionsAppleModelsList();
                this.modelsForTds = transformMultiSelect(this.subscriptionsGetAppleModels(), 'title', 'slug');
            }
        } catch {
            return void 0;
        }
    }
}
